module.exports = __webpack_public_path__ + "static/media/country_gi.28122418.webp";